import type { AbilityDimension, SkillCategory, TeamRole } from './types.js';

/**
 * 展示用中文标签的**唯一来源**。
 *
 * 为什么放在领域层：这些词会同时出现在
 * ① 后端返回的可解释理由里（如"自评短板：设计"）、
 * ② 前端标签与看板列名、
 * ③ 成队后自动生成的 4 条阶段待办标题。
 * 三处若各写一份，迟早出现"同一维度两种叫法"，评委一眼就能看出拼接痕迹。
 */

/** 能力维度中文名（长板/短板与理由文案共用） */
export const ABILITY_LABELS: Record<AbilityDimension, string> = {
  tech: '技术实现',
  design: '设计',
  business: '商业',
  data: '数据',
  content: '内容',
  speech: '表达',
};

export function abilityLabel(id: string): string {
  return ABILITY_LABELS[id as AbilityDimension] ?? id;
}

/** 技能大类中文名（能力结构图/雷达图用） */
export const CATEGORY_LABELS: Record<SkillCategory, string> = {
  dev: '开发',
  design: '设计',
  business: '商业',
  data: '数据',
  content: '内容',
  speech: '表达',
  domain: '专业',
};

export function categoryLabel(id: string): string {
  return CATEGORY_LABELS[id as SkillCategory] ?? id;
}

/** 队伍角色中文名 */
export const ROLE_LABELS: Record<TeamRole, string> = {
  leader: '队长',
  tech: '技术',
  design: '设计',
  business: '商业',
  content: '内容',
  member: '成员',
};

export function roleLabel(id: string): string {
  return ROLE_LABELS[id as TeamRole] ?? id;
}

/** 四个阶段的中文名（成队后自动生成的待办标题用它，避免前后端各写一套） */
export const PHASE_LABELS: Record<1 | 2 | 3 | 4, string> = {
  1: '阶段一·立项与选题',
  2: '阶段二·开发与打磨',
  3: '阶段三·材料与路演',
  4: '阶段四·彩排与提交',
};

export function phaseLabel(phase: number): string {
  return PHASE_LABELS[phase as 1 | 2 | 3 | 4] ?? `阶段 ${phase}`;
}

/** 队伍/项目状态中文名 */
export const TEAM_STATUS_LABELS: Record<string, string> = {
  forming: '组队中',
  confirmed: '已成队',
  archived: '已归档',
};

export const TASK_STATUS_LABELS: Record<string, string> = {
  todo: '待办',
  doing: '进行中',
  done: '已完成',
};

export const MEMBER_STATUS_LABELS: Record<string, string> = {
  invited: '已邀请',
  accepted: '已加入',
  declined: '已拒绝',
  requested: '待审批',
};

/** 准入档标签（扩展② 组队大厅）。 */
export const JOIN_POLICY_LABELS: Record<string, string> = {
  open: '免审核',
  approval: '需审批',
  invite_only: '仅邀请',
};

export function joinPolicyLabel(id: string): string {
  return JOIN_POLICY_LABELS[id] ?? id;
}

export function teamStatusLabel(id: string): string {
  return TEAM_STATUS_LABELS[id] ?? id;
}

export function taskStatusLabel(id: string): string {
  return TASK_STATUS_LABELS[id] ?? id;
}

export function memberStatusLabel(id: string): string {
  return MEMBER_STATUS_LABELS[id] ?? id;
}